<template>
  <v-form ref="form" @submit.prevent="handlerContinue" lazy-validation>
    <v-row :class="!mdAndUp ? 'd-flex flex-column' : ''">
      <v-col md="3" sm="12">
        <v-card :class="['rounded-lg', mdAndUp && 'mr-3 mb-12']" elevation="0">
          <v-card-title>
            <v-icon class="mr-2">mdi-text</v-icon>
            Informações Básicas
          </v-card-title>
          <v-card-subtitle class="ml-1">
            Informe as informações básicas do seu combo.
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col md="9" sm="12">
        <v-card class="rounded-lg mb-12" elevation="0">
          <v-col md="10" sm="12" class="pt-0">
            <v-card-title class="text-h6">
              <v-icon class="mr-2"> mdi-tag-text-outline </v-icon>
              Dados do Combo</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <BaseTextField
                    label="Descrição"
                    required
                    v-model="basicInfo.description"
                    :rules="[rules.required]"
                    placeholder="Insira a descrição do combo"
                  >
                    <v-tooltip bottom slot="append">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          color="tertiary"
                          @click="openBottomSheet"
                        >
                          mdi-flag-outline
                        </v-icon>
                      </template>
                      <span>Traduções</span>
                    </v-tooltip>
                  </BaseTextField>
                  <v-navigation-drawer
                    temporary
                    right
                    app
                    v-model="bottom"
                    width="500"
                  >
                    <v-card class="rounded-lg" height="300px" elevation="0">
                      <v-col cols="12" sm="12" md="12">
                        <v-card-title class="text-h6">
                          <v-icon class="mr-2"> mdi-translate </v-icon>
                          Adicione Traduções no seu combo
                          <v-spacer></v-spacer>
                          <v-btn class="mt-0 mr-0" icon @click="bottom = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <BaseTextField
                                label="Descrição - Inglês"
                                v-model="basicInfo.description_en"
                                placeholder="Insira a descrição do combo"
                              >
                              </BaseTextField>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                              <BaseTextField
                                label="Descrição - Espanhol"
                                v-model="basicInfo.description_es"
                                placeholder="Insira a descrição do combo"
                              >
                              </BaseTextField>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="dark"
                            class="rounded-lg"
                            text
                            @click="cancelTranslate"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            class="rounded-lg"
                            color="button"
                            @click="bottom = false"
                            >Confirmar</v-btn
                          >
                        </v-card-actions>
                      </v-col>
                    </v-card>
                  </v-navigation-drawer>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <BaseTextField
                    label="Quantidade"
                    required
                    :rules="[rules.required, rules.minQuantity(1)]"
                    type="number"
                    v-model="basicInfo.quantity"
                    placeholder="Insira a quantidade de combos"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <BaseSelect
                    label="Status"
                    required
                    placeholder="Selecione o status"
                    :items="status"
                    :attach="false"
                    :rules="[rules.required]"
                    v-model="basicInfo.status"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="text-h6">
              <v-icon class="mr-2"> mdi-map-marker-radius-outline </v-icon>
              Endereço</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <BaseTextField
                    label="Local do Combo"
                    placeholder="Insira o local do combo"
                    v-model="basicInfo.address"
                  >
                  </BaseTextField>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <BaseAutocomplete
                    label="País"
                    item-text="dsc_lang"
                    return-object
                    placeholder="Selecione o país"
                    autocomplete="null"
                    auto-select-first
                    :loading="$config.loading_paises"
                    :items="$config.paises.result"
                    v-model="basicInfo.country"
                  >
                  </BaseAutocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <BaseAutocomplete
                    label="Estado"
                    item-text="dsc_lang"
                    item-value="iso"
                    return-object
                    placeholder="Selecione o estado"
                    autocomplete="null"
                    auto-select-first
                    :loading="$config.loading_estados"
                    :items="$config.estados.result"
                    v-model="basicInfo.state"
                  >
                  </BaseAutocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <BaseAutocomplete
                    label="Cidade"
                    item-text="dsc_lang"
                    item-value="iso_full"
                    :attach="false"
                    placeholder="Selecione a cidade"
                    :loading="$config.loading_cidades"
                    :items="$config.cidades.result"
                    v-model="basicInfo.city"
                  >
                  </BaseAutocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title class="text-h6">
              <v-icon class="mr-2"> mdi-calendar-multiple </v-icon>
              Defina o período de vendas do seu combo</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        required
                        readonly
                        label="Data de início"
                        type="tel"
                        v-model="basicInfo.initDateView"
                        v-bind="attrs"
                        v-on="on"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        append-icon="mdi-calendar-outline"
                        :rules="[rules.required]"
                        :validate-on-blur="false"
                      >
                      </BaseTextField>
                    </template>
                    <v-date-picker
                      v-model="basicInfo.initDate"
                      :active-picker.sync="activePicker"
                      :min="minInitDate"
                      @change="save"
                      locale="pt"
                      color="primary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        required
                        label="Hora de início"
                        type="tel"
                        v-bind="attrs"
                        readonly
                        v-on="on"
                        placeholder="hh:mm"
                        v-mask="'##:##'"
                        append-icon="mdi-clock-outline"
                        v-model="basicInfo.initHour"
                        :rules="[rules.required]"
                        :validate-on-blur="false"
                      >
                      </BaseTextField>
                    </template>
                    <v-time-picker
                      v-model="basicInfo.initHour"
                      :active-picker.sync="activePicker2"
                      @change="save2"
                      locale="pt"
                      scrollable
                      format="24hr"
                      color="primary"
                      range
                    >
                    </v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        required
                        label="Data de término"
                        v-model="basicInfo.endDateView"
                        type="tel"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        placeholder="dd/mm/aaaa"
                        v-mask="'##/##/####'"
                        append-icon="mdi-calendar-outline"
                        :rules="[rules.required]"
                        :validate-on-blur="false"
                      >
                      </BaseTextField>
                    </template>
                    <v-date-picker
                      v-model="basicInfo.endDate"
                      :active-picker.sync="activePicker3"
                      :min="minEndDate"
                      no-title
                      scrollable
                      @change="save3"
                      locale="pt"
                      color="primary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-menu
                    ref="menu4"
                    v-model="menu4"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <BaseTextField
                        required
                        label="Hora de término"
                        type="tel"
                        v-bind="attrs"
                        readonly
                        v-on="on"
                        placeholder="hh:mm"
                        v-mask="'##:##'"
                        append-icon="mdi-clock-outline"
                        v-model="basicInfo.endHour"
                        :rules="[rules.required]"
                        :validate-on-blur="false"
                      >
                      </BaseTextField>
                    </template>
                    <v-time-picker
                      v-model="basicInfo.endHour"
                      :active-picker.sync="activePicker4"
                      @change="save4"
                      locale="pt"
                      format="24hr"
                      scrollable
                      header-color="primary"
                      color="primary"
                      range
                    >
                    </v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-card-actions v-if="getComboType === 'new'">
      <v-spacer></v-spacer>
      <v-btn color="primary" type="submit"> Continue </v-btn>
    </v-card-actions>
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import dayjs from "dayjs";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import mixins from "@/mixins";

const { formRules } = mixins;
export default {
  name: "basicInformation",
  mixins: [displayHelpers, formRules],
  data() {
    return {
      bottom: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
      basicInfo: {
        description: "",
        description_en: "",
        description_es: "",
        quantity: null,
        status: "ATIVO",
        address: null,
        country: "Brasil",
        state: null,
        city: null,
        initDate: "",
        initDateView: "",
        initHour: "",
        endDate: "",
        endDateView: "",
        endHour: "",
      },
      status: [
        { text: "Ativo", value: "ATIVO" },
        { text: "Inativo", value: "INATIVO" },
        { text: "Esgotado", value: "ESGOTADO" },
      ],
    };
  },
  components: {
    BaseTextField,
    BaseSelect,
    BaseAutocomplete,
  },
  computed: {
    ...mapGetters(["comboModal", "getComboType", "getBasicInformation"]),
    minInitDate() {
      return dayjs().format("YYYY-MM-DD");
    },
    minEndDate() {
      return dayjs(this.basicInfo.initDate).add(1, "day").format("YYYY-MM-DD");
    },
  },
  watch: {
    "basicInfo.country": {
      handler(country) {
        if (!country || !this.comboModal) return;
        const { id } = country;
        this.$config.getEstados(id || "9e1bf96ca2754ee6596f26fd6e6b5cc2");
      },
      deep: true,
    },
    "basicInfo.state": {
      async handler(state) {
        if (!state || !this.$config.estados || !this.comboModal) return;
        await this.waitForEstadosResult();

        const { id } = state;
        const filteredId = this.$config.estados.result.find(
          item => item.iso === state || item.id === id
        );
        if (filteredId) {
          await this.$nextTick();
          this.$config.getCidades(id || filteredId.id);
        } else {
          console.warn("State not found:", state);
        }
      },
      deep: true,
    },
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "HOUR"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "MONTH"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
    comboModal(val) {
      this.getInfos(val);
    },
  },
  methods: {
    ...mapActions(["saveBasicInformation", "showSnackbarError"]),
    waitForEstadosResult() {
      return new Promise(resolve => {
        const checkEstados = () => {
          if (this.$config.estados && this.$config.estados.result) {
            resolve();
          } else {
            setTimeout(checkEstados, 50);
          }
        };
        checkEstados();
      });
    },

    handlerContinue() {
      if (!this.$refs.form.validate()) {
        this.showSnackbarError("Preencha os campos obrigatórios!");
        return false;
      }
      this.saveBasicInformation(this.basicInfo);
      return true;
    },
    getInfos(val) {
      if (val && this.getComboType === "new") {
        this.basicInfo = {
          description: "",
          description_en: "",
          description_es: "",
          quantity: null,
          status: "ATIVO",
          address: null,
          country: "Brasil",
          state: null,
          city: null,
          initDate: "",
          initDateView: "",
          initHour: "",
          endDate: "",
          endDateView: "",
          endHour: "",
        };

        this.menu = false;
        this.menu2 = false;
        this.menu3 = false;
        this.menu4 = false;
        this.activePicker = null;
        this.activePicker2 = "HOUR";
        this.activePicker3 = null;
        this.activePicker4 = "HOUR";

        this.$refs.form.resetValidation();
      } else {
        const {
          description,
          description_en,
          description_es,
          quantity,
          status,
          address,
          country,
          state,
          city,
          initDate,
          initHour,
          endDate,
          endHour,
        } = this.getBasicInformation;

        this.basicInfo = {
          description,
          description_en,
          description_es,
          quantity,
          status,
          address,
          country,
          state,
          city,
          initDate,
          initDateView: dayjs(initDate).format("DD/MM/YYYY"),
          initHour,
          endDate,
          endDateView: dayjs(endDate).format("DD/MM/YYYY"),
          endHour,
        };
      }
    },
    openBottomSheet() {
      this.bottom = true;
    },
    cancelTranslate() {
      this.basicInfo.description_en = "";
      this.basicInfo.description_es = "";
      this.bottom = false;
    },
    save(date) {
      this.$refs.menu.save(date);
      this.basicInfo.initDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save2(hour) {
      this.$refs.menu2.save(hour);
      this.basicInfo.initHour = hour;
    },
    save3(date) {
      this.$refs.menu3.save(date);
      this.basicInfo.endDateView = dayjs(date).format("DD/MM/YYYY");
    },
    save4(hour) {
      this.$refs.menu4.save(hour);
      this.basicInfo.endHour = hour;
    },
  },
  mounted() {
    this.$config.getPaises();
    this.getInfos(this.comboModal);
  },
};
</script>
